module.exports = __webpack_public_path__ + "static/media/rjit.6c42f3c6.png";